<template>
  <v-card
    color="#173862"
    elevation="0"
    class="mx-0 px-0 pt-4"
    height="100%"
    
  >
    <v-card-text class="px-5 py-10">
      <p class="font-weight-normal white--text">
        {{ $t('registration.panel.title') }}
      </p>
      <ul class="font-weight-normal white--text">
        <li>{{ $t('registration.panel.li1') }}</li>
        <li>{{ $t('registration.panel.li2') }}</li>
        <li>{{ $t('registration.panel.li3') }}</li>
        <li>{{ $t('registration.panel.li4') }}</li>
        <li>{{ $t('registration.panel.li5') }}</li>
        <li>{{ $t('registration.panel.li6') }}</li>
        <li>{{ $t('registration.panel.li7') }}</li>
      </ul>
    </v-card-text>

    <v-card-actions>
      <v-row
        align="center"
        justify="center"
      >
        <p class="font-weight-black start-trial">{{ $t('registration.panel.startTrial') }}</p>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    name: "SignupPanel"
  }
</script>

<style lang="scss" scoped>
  ul {
    list-style: none;
    font-size: 18px;
  }

  ul li::before {
    content: "\2022";
    color: #F2A81D;
    display: inline-block; 
    width: 1em;
    margin-left: -1em;
  }

  li {
    margin-top: 28px;
    text-align: left;
  }

  p {
    font-size: 18px;
  }

  .start-trial{
    color: #F2A81D;
  }
</style>